// -*- Mode: rjsx -*-
import React, { useState}  from 'react';
import axios from 'axios';
import qs from 'qs';

import Morty from '../data/Morty';

import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

import SendIcon from '@mui/icons-material/Send';
import SyncIcon from '@mui/icons-material/Sync';

// import Avatar from '@mui/material/Avatar';
import Grid  from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';

import Slide from '@mui/material/Slide';

import { FHMaterialStyles, FHSideContainer } from "../ui/fh-material-styles.js";
import EmailSent from '../ui/EmailSent';

function SendButton(props) {
    const classes = FHMaterialStyles();

    if (props.sending) {
        return (<Button
                  className={classes.button}
                  type="submit"
                  fullWidth
                  name="submit"
                  variant="contained"
                  endIcon={<SyncIcon />}                  
                  disabled
                >
                  Sending
                </Button>);
    }
    return (
        <Button
          className={classes.button}
          type="submit"
          fullWidth
          name="submit"
          variant="contained"
          color="primary"
          endIcon={<SendIcon />}
        >
          Send Reset Link
        </Button>
    );
}




function PasswordReset() {

    let qsEmail = qs.parse(window.location.search, { ignoreQueryPrefix: true }).email;
    const [errors, setErrors] = useState([]);
    const [email, setEmail] = useState(qsEmail || '');
    const [sent, setSent] = useState(false);
    const [sending, setSending] = useState(false);
    
    let sendTo = qs.parse(window.location.search, { ignoreQueryPrefix: true }).send_to;
    
    const handleSubmit = (event) => {
        
        event.preventDefault();

        if(!email.length) {
            setErrors(['Invalid Email', 'Double check that email address']);
            return;
        }

        let payload = { email: email };
        if(sendTo)
            payload['send_to'] = sendTo;

        setSending(true);
        setErrors([]);        
	    Morty
            .post('/morty/auth/password/start-reset/', payload)
            .then((data) => {
                setSent(true);
                setSending(false);                
            }).
            catch((data) => {
                console.log(data);
                setErrors(["Oops", "There was an error, try again."]);
            });
        
        
    };

    const handleChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        if(name == 'email')
            setEmail(value);
    };

    const classes = FHMaterialStyles();
    let errorDisplay = null;

    if(errors.length) {
        let errorStyle = { color: '#9B0202' };

        errorDisplay = (
            <div>
              <h2 style={errorStyle}>{ errors[0] }</h2>
              <h3 style={errorStyle}>{ errors[1] }</h3>
            </div>
        );
    }


    let first = qs.parse(window.location.search, { ignoreQueryPrefix: true }).first;
    let setOrReset = first ? 'Set' : 'Reset';
    
	return (
        
        <FHSideContainer>
          { sent &&  <EmailSent /> }
          
          { !sent &&
		    <form onSubmit={handleSubmit} noValidate>

            {errorDisplay}

            <Typography component="h2" variant="h5" align="center">
              { setOrReset} your password
            </Typography>
            
            <Grid container>
              <Grid item xs>
                <Typography align="center">
                  Let&apos;s confirm your email address.
                </Typography>
              </Grid>
            </Grid>            
            
            <TextField
              onChange={handleChange}
              value={email}
              variant="outlined"
              margin="normal"
              type="email"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />

            <SendButton sending={sending} />

          </form>
          }

          
          <div style={{ marginTop: 50,
                        borderTop: "1px solid #D0D0D0",
                        paddingTop: 50
                      }}>

            <Typography variant="h6" align="center" color="textSecondary">
              Why do we send this email?
            </Typography>
            
            <Typography variant="body2" align="center" color="textSecondary">
              In order to update your password, we need to verify that you are... well... you. We&apos;ll email you a link, you&apos;ll click it, and you can update your password. 
            </Typography>
          </div>
          
          
        </FHSideContainer>
	);

    
}




export default PasswordReset;
